// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Tabs = ((($) => {
  let sliderMain;
  let sliderNav;
  let sliderNavLink;
  let sliderActiveHeight;
  let sliderNavActive;
  let leftOffset;
  let link;
  function init() {
    sliderMain = $('.Tabs-body');
    if(sliderMain.length) {
      sliderNav = $('.Tabs-list');
      sliderNavLink = $('.Tabs-list a');
      sliderActiveHeight = $('.Tabs-body .active').height();
      sliderNavActive = sliderNav.find('.active');
      if ($(window).width() > 992) {
        leftOffset = sliderNavActive.position().left + 30;
      }
      else{
        leftOffset = sliderNavActive.position().left + 10;
      }
      $('.tabs-ind').css({'left': leftOffset, 'width':sliderNavActive.width()});
      sliderMain.css('height', sliderActiveHeight+30);
      $(sliderNavLink).on('click', function(e) {
        e.preventDefault();
        link = $(this).attr('href');

        //Change class in tabs-switcher
        sliderNav.find('.active').removeClass('active');
        $(this).addClass('active');

        //Change class in tabs with table
        sliderMain.find('.active').removeClass('active');
        sliderMain.find(link).addClass('active');

        //Change height of section with table
        sliderActiveHeight = $('.Tabs-body .active').height();
        sliderMain.css('height', sliderActiveHeight+30);

        //Move active tab indicator
        sliderNavActive = $('.Tabs-list a.active');
        if ($(window).width() > 992) {
          leftOffset = sliderNavActive.position().left + 30;
        }
        else{
          leftOffset = sliderNavActive.position().left + 10;
        }

        $('.tabs-ind').css({'left': leftOffset, 'width':sliderNavActive.width()});


      });
    }
  }

  return {
    init,
  };
}))(jQuery);

export default Tabs;


// WEBPACK FOOTER //
// ./src/static/js/modules/tabs.js